import React from 'react';

import SetPasswordFromInviteLink from 'src/components/user-flow/set-password-from-invite-link';

export default function SetPasswordRoute() {
  return <SetPasswordFromInviteLink />;
}
